export default "__VITE_ASSET__Dw7YWXmb__"